import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { responseError } from '../../../helpers/response/ResponseHelper'
import MySelect from '../../UI/form/MySelect'
import { getDeliveryTypesAllAPI } from '../../../api/delivery/deliveryTypeAPI'

const DeliveryTypesSelectMain = ({ required, setValidate, setValueForm, forciblyValue }) => {

    const [value, setValue] = useState(forciblyValue)
	const [deliveryTypes, setDeliveryTypes] = useState([])

	useEffect(() => {
		getDeliveryTypes()
	}, [])

	useEffect(() => {
		valid()
	}, [required, value])

	const getDeliveryTypes = () => {
		getDeliveryTypesAllAPI().then(data => {
			setDeliveryTypes(data)
		}).catch(e => {
			// setError(responseError(e))
			console.error(responseError(e))
		})
	}

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
			} else {
				setValidate(false)
			}
		} else {
			setValidate(true)
		}
	}

  return (
    <MySelect
        value={value}
        label="Тип доставки"
        labelId="select__deliveryType-label"
        id='select__deliveryType'
        onChange = {e => {
			setValueForm(e)
            setValue(e)
			// setEvent({...event, categoryId: e})
		}}
        nameField='Тип доставки'
        // sx={{width: '200px'}}
        options={
			deliveryTypes && deliveryTypes.length > 0 ? 
				deliveryTypes.map(goodType => {
            		return {id: goodType.id, name: goodType.name}
				})
			: []	
		}
        // options={[]}
    />
  )
}

export default DeliveryTypesSelectMain